import React from 'react'
import styled from 'styled-components'
import ProductBarcode from 'Components/utilities/ProductBarcodePrint'
import { cmToPx, numberWithComma } from 'helpers/format'
import { menuPaperSize } from 'helpers/constanst'

type Props = {
  barcode?: string
  title?: string
  price?: number
  configData?: any
  uom: string
}

const Type2: React.FunctionComponent<Props> = props => {
  const { barcode = '', title = '', price, configData, uom } = props
  const showName = configData?.enableName || false
  const showPrice = configData?.enablePrice || false
  const showUom = configData?.enableUom || false
  const paperType = configData?.paperType || '1'
  const paper = getPaperSpec(paperType)

  return (
    <BarcodeWraper about={paperType}>
      <BoxAbs>
        {showName ? (
          <ProductName about={paperType}>{title}</ProductName>
        ) : (
          <ProductNameHide about={paperType}>{title}</ProductNameHide>
        )}
        <ProductBarcode barcode={barcode} height={paper?.bh || 0} width={paper?.bw || 0} />
        {showPrice ? (
          <ProductPrice>
            {' '}
            {showPrice ? `${numberWithComma(price)} บาท` : ' '}
            {showUom ? `/${uom}` : ''}
          </ProductPrice>
        ) : (
          <ProductPriceHide>
            {' '}
            {`${numberWithComma(price)} บาท`}
            {showUom ? `/${uom}` : ''}
          </ProductPriceHide>
        )}
      </BoxAbs>
    </BarcodeWraper>
  )
}

const getPaperSpec = (type: string) => {
  return menuPaperSize.find(item => item.value === type)?.spec
}

const getPaperSize = (props: any): string => {
  const type = props.about
  const paper = getPaperSpec(type)
  const inpx = cmToPx(paper?.paper || 0)

  return `${inpx}px`
}

const getStickerWidth = (props: any): string => {
  const type = props.about
  const paper = getPaperSpec(type)
  const inpx = cmToPx(paper?.w || 0)

  return `${inpx}px`
}

const getStickerHeight = (props: any): string => {
  const type = props.about
  const paper = getPaperSpec(type)
  const inpx = cmToPx(paper?.h || 0)

  return `${inpx}px`
}

const getMarginLeft = (props: any): string => {
  const type = props.about
  const paper = getPaperSpec(type)
  const inpx = cmToPx(paper?.space || 0)

  return `${inpx}px`
}

const getBarcodeHeight = (props: any): string => {
  const type = props.about
  const paper = getPaperSpec(type)
  const inpx = cmToPx((paper?.h || 0) - 1.2)

  return `${inpx}px`
}

const getBarcodeWidth = (props: any): string => {
  const type = props.about
  const paper = getPaperSpec(type)
  const inpx = cmToPx((paper?.w || 0) - 0.5)

  return `${inpx}px`
}

const getNameWidth = (props: any): string => {
  const type = props.about
  const paper = getPaperSpec(type)
  const inpx = cmToPx((paper?.w || 0) - 0.3)

  return `${inpx}px`
}

const BarcodeWraper = styled.div`
  text-align: center;
  width: ${getStickerWidth};
  height: ${getStickerHeight};
  margin-right: ${getMarginLeft};
  //background-color: yellow;
  border-radius: 5px;
  svg {
    width: ${getBarcodeWidth} !important;
    height: ${getBarcodeHeight} !important;
  }
  position: relative;
`

const ProductName = styled.div`
  font-size: 9px;
  font-family: arial;
  font-style: normal;
  color: #000;
  max-width: ${getNameWidth};
  white-space: nowrap;
  overflow: hidden;
  display: block;
  text-overflow: ellipsis;
  margin: 0 auto;
  padding-top: 12px;
  font-family: 'Tahoma';
`

const ProductNameHide = styled(ProductName)`
  color: #fff;
`

const ProductPrice = styled.div`
  font-size: 12px;
  font-family: arial;
  font-style: normal;
  color: #000;
  font-family: 'Tahoma';
`

const ProductPriceHide = styled(ProductPrice)`
  color: #fff;
`

const BoxAbs = styled.div`
  // position: absolute;
  // top: 50%;
  // left: 50%;
  // transform: translate(-50%, -50%);
  //padding-top: 10px;
`

export default Type2
